import { Component, OnInit } from '@angular/core';
import { FbImageWidget, FormConfig, FormSection, ImageProperty } from '@nrwl/rx-form-builder';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { catchError, take } from 'rxjs/operators';

import { EMPTY } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { RxComposite } from '../../model/rx-composite';
import { SnackbarService } from '@nrwl/snackbar-services';
import { UserFile } from '@nrwl/rx-models';
import { UserFileService } from '@nrwl/rx-service-userfile';
import { rxRequiredValidator } from '@nrwl/rx-validators';
import { CommonModule } from '@angular/common';
import { RxInputModule } from '@nrwl/rx-input';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxTabsModule } from '@nrwl/rx-tabs';

@Component({
  selector: 'rx-upload-branded',
  templateUrl: './rx-upload-branded.component.html',
  styleUrls: ['./rx-upload-branded.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxInputModule,
    RxIconModule,
    RxTabsModule,
  ],
})
export class RxUploadBrandedComponent extends RxComposite implements OnInit {
  public isBusy = false;
  private _selectedTab = 0;
  public get selectedTab() {
    return this._selectedTab;
  }
  public set selectedTab(value) {
    this.payload.type = value === 0 ? 2 : 1;
    this._selectedTab = value;
  }

  public templateData: any = null;
  public formGroup: FormGroup;
  public filesSelected;
  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private userFileService: UserFileService,
    private snackbarService: SnackbarService,
  ) {
    super();
  }

  public get formAssembled() {
    return this.templateData instanceof FormConfig;
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      name: new FormControl('', [
        rxRequiredValidator,
        Validators.minLength(2),
        Validators.maxLength(50),
      ]),
    });
  }

  public selectFile(event): void {
    const files = event.target.files;

    if (files && files.length > 0) {
      this.filesSelected = files;
      this.upload(files);
    }
  }

  private upload(files): void {
    if (files && files.length > 0) {
      this.isBusy = true;
      const formData = new FormData();
      formData.append('file', this.filesSelected[0]);

      // Convert PDF to array of Images
      this.userFileService
        .rasterize(formData)
        .pipe(
          take(1),
          catchError((err: any) => {
            this.snackbarService.error(
              'An error occured while processing your request. Please try again later.',
            );
            this.isBusy = false;
            return EMPTY;
          }),
        )
        .subscribe((userFiles: [UserFile]) => {
          // Assemble branded form from images
          this.assembleBrandedFormFromImages(userFiles);
        });
    }
  }

  private assembleBrandedFormFromImages(userFiles: [UserFile]): void {
    const formConfig = new FormConfig();
    formConfig.sections = [];
    userFiles.forEach((item) => {
      const section = new FormSection();
      const imageWidget = new FbImageWidget({
        properties: {
          hideLabel: {
            group: 'Appearance',
            type: 'checkbox',
            title: 'Hide Label',
            value: 1,
            mapping: '',
          },
          value: new ImageProperty({ value: item.id }),
        },
      });
      section.widgets.push(imageWidget);
      formConfig.sections.push(section);
    });
    this.templateData = formConfig;
    this.isBusy = false;
  }

  public override isValid(): boolean {
    this.payload.type = this.selectedTab === 0 ? 2 : 1; // 1: Branded form 2: Editable form

    if (this.selectedTab === 0) {
      if (!this.formGroup.valid) {
        this.snackbarService.error('Error. Template name is required.');
        return false;
      }
      this.payload.data = this.formGroup.value;
    }

    if (this.selectedTab === 1) {
      if (!(this.templateData instanceof FormConfig)) {
        this.snackbarService.error('Error. Please upload high quality PDF form.');
        return false;
      }
      this.payload.data = this.templateData;
    }

    return true;
  }

  public close(): void {
    if (this.dialog && this.dialog.close) {
      this.dialog.close();
    }
  }
}
